import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaBriefcase,
  FaShoppingCart,
  FaMobileAlt,
  FaRocket,
  FaEye,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const MobileFriendlyEcommerceDevelopmentInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Mobile-Friendly E-commerce Development in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Shop Anywhere</Subheading>}
        heading={
          <Heading>
            Mobile-Friendly{" "}
            <span tw="text-primary-500">E-commerce Development</span> in DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we specialize in mobile-friendly e-commerce
            development in **DIFC**, crafting responsive, high-performance
            online stores that deliver seamless shopping experiences across all
            devices in Dubai’s financial hub.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1593642702821-c8da6771f0c6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Mobile shopping experience
          "https://images.unsplash.com/photo-1616469829941-c7200edec809?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Mobile e-commerce development
          "https://images.unsplash.com/photo-1556740772-1a741367b93e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Customer using mobile shopping app
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Build Mobile-Friendly Now"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Responsive E-commerce Excellence in DIFC"
        description="We prioritize mobile-first designs for optimal performance."
        cards={[
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Responsive Design",
            description: "Flawless display on phones, tablets, and more.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Mobile Sales",
            description: "Optimized for conversions on the go.",
          },
          {
            icon: <FaBriefcase color="#ff5464" size={40} />,
            title: "Expert Developers",
            description: "Crafted by DIFC’s top e-commerce pros.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Loading",
            description: "Speedy mobile stores for user retention.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Visual Appeal",
            description: "Stunning designs tailored for mobile.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted in DIFC",
            description: "Preferred for mobile-friendly stores.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Mobile-First Development Process"
        description={
          <Description>
            We create mobile-friendly e-commerce stores with precision:
            <ul tw="mt-4 list-disc pl-6">
              <li>Planning: Define mobile-focused business goals.</li>
              <li>Design: Craft responsive, intuitive layouts.</li>
              <li>Development: Build scalable, mobile-optimized platforms.</li>
              <li>Testing: Ensure performance across devices.</li>
              <li>Launch: Deliver a seamless mobile store.</li>
              <li>Support: Provide ongoing mobile enhancements.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1555774698-0b77e0d5fac6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Mobile website development
          "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Team collaborating on mobile design
          "https://images.unsplash.com/photo-1481437156560-3205f6a55735?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Mobile responsive testing
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Our Achievements</Subheading>}
        heading="Mobile Success in DIFC"
        description="Our mobile-friendly stores drive results."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Surge",
            description: "Boosted mobile conversions by 150%.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "User Engagement",
            description: "Improved retention with responsive design.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "95% approval from DIFC clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Mobile?</Subheading>}
        heading="Mobile-Friendly E-commerce in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset for mobile-friendly e-commerce
            development in DIFC. Launch a responsive, high-performing store that
            captivates customers—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1586880244406-556ebe35f282?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Mobile e-commerce success
          "https://images.unsplash.com/photo-1559526324-593bc073d938?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Dubai skyline with person using smartphone
          "https://images.unsplash.com/photo-1611162618071-b39a2ec055fb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1500&q=80", // Mobile payment/checkout
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
